import React, { ForwardedRef } from "react";
import { Box, Stack, BoxProps } from "@mui/material";
import { ITagBroker } from "src/api/server/extended-search.types";
import { handleBrokersIds } from "src/components/pages/search/store/actions";
import { useSearchStore } from "src/components/pages/search/store/search-store";
import { BrokerCheckbox, IBrokerOnChangeParams } from "./broker-checkbox";

interface IBrokersCheckboxListProps extends BoxProps {
    brokers: ITagBroker[];
    pt?: number;
}

function BrokersCheckboxListComponent({ brokers, pt, ...boxProps }: IBrokersCheckboxListProps, ref: ForwardedRef<HTMLDivElement>) {
    const { brokersIds } = useSearchStore();

    const onChange = ({ isChecked, brokerId }: IBrokerOnChangeParams) => {
        handleBrokersIds({ isChecked, brokerId });
    };

    return (
        <Box
            ref={ref}
            {...boxProps}
            sx={[
                {
                    pt: pt,
                },
                ...(Array.isArray(boxProps.sx) ? boxProps.sx : [boxProps.sx]),
            ]}
        >
            <Stack
                direction="row"
                sx={{
                    flexWrap: "wrap",
                    gap: 3,
                }}
            >
                {brokers.map(broker => (
                    <BrokerCheckbox key={broker.brokerId} broker={broker} onChange={onChange} isChecked={brokersIds.includes(broker.brokerId)} />
                ))}
            </Stack>
        </Box>
    );
}

export const BrokersCheckboxList = React.forwardRef(BrokersCheckboxListComponent);
